const DEFAULT_MAX_TITLE_NAMES = 2;
const DEFAULT_MAX_NAME_LENGTH = 30;

export function buildDailyInsightTitle({
  locale = 'en',
  reportDate = 'latest',
  candidates = [],
  noStrongOpportunity = null,
  maxNames = DEFAULT_MAX_TITLE_NAMES,
  latest = false,
} = {}) {
  const zh = isZhLocale(locale);
  const names = candidateNames(candidates, maxNames);
  const count = Array.isArray(candidates) ? candidates.length : 0;
  const date = displayDailyInsightDate(reportDate, locale);

  if (!names.length || (noStrongOpportunity?.value === true && count === 0)) {
    if (latest) {
      return zh ? '今天没有高置信度 App 机会' : 'No High-Confidence App Opportunities Today';
    }
    return zh
      ? `没有高置信度 App 机会 — ${date}`
      : `No High-Confidence App Opportunities — ${date}`;
  }

  const more = count > names.length;
  if (zh) {
    const namePart = `${names.join('、')}${more ? ' 等' : ''}`;
    return latest
      ? `今日 Top 5 App 机会：${namePart}`
      : `Top 5 App 机会：${namePart} — ${date}`;
  }

  const namePart = englishNameList(names, more);
  return latest
    ? `Top 5 App Opportunities Today: ${namePart}`
    : `Top 5 App Opportunities: ${namePart} — ${date}`;
}

export function displayDailyInsightDate(date, locale = 'en') {
  const zh = isZhLocale(locale);
  const parsed = new Date(`${date}T00:00:00Z`);
  if (Number.isNaN(parsed.getTime())) return String(date ?? (zh ? '最新' : 'Latest'));
  if (zh) {
    const match = String(date ?? '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return new Intl.DateTimeFormat('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    }).format(parsed);
    return `${match[1]}年${Number(match[2])}月${Number(match[3])}日`;
  }
  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(parsed);
}

function candidateNames(candidates, maxNames) {
  return (Array.isArray(candidates) ? candidates : [])
    .map((candidate) => candidate?.name ?? candidate?.appName)
    .filter((name) => typeof name === 'string' && name.trim())
    .slice(0, Math.max(0, maxNames))
    .map((name) => truncateName(name.trim()));
}

function englishNameList(names, hasMore) {
  if (names.length === 1) return `${names[0]}${hasMore ? ' and More' : ''}`;
  const joined = `${names[0]}, ${names[1]}`;
  return hasMore ? `${joined} and More` : joined;
}

function truncateName(value, max = DEFAULT_MAX_NAME_LENGTH) {
  const chars = Array.from(value);
  if (chars.length <= max) return value;
  return `${chars.slice(0, Math.max(1, max - 3)).join('').trim()}...`;
}

function isZhLocale(locale) {
  return String(locale ?? '').toLowerCase().startsWith('zh');
}
